import React from 'react';
import Modal from '../../component/Inc/Modal';

function PopMatching(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} popSize="xs" type="pop_select_subject">
      <div className="pop_tit">매칭 확인</div>
      <div className="content_container">
        <p className="pop_cont"><strong>실 입금된 금액 입력</strong></p>
				<div className="pop_input"> 
        <input type="text" className="input" placeholder="실 입금된 금액 입력" />
				</div>
      </div>
      <div className="btn_container">
        <button className="com_btn gray xs">취소</button>
        <button className="com_btn orange xs">확인</button>
      </div>
    </Modal>
  );
}

export default PopMatching;
